<template>
    <v-row
        justify="center"
    > 
        <v-col>        
            <v-card
                class="mx-auto pa-0"
                width="720"               
            >
                <v-card-title
                    class="d-flex white--text  py-2 px-0 primary"
                >
                    <v-spacer></v-spacer>
                    <div class="caption font-weight-light text-uppercase">Mark Sheet</div>
                    <v-spacer></v-spacer>
                    <v-btn
                        text                
                        x-small
                        color="white"
                        @click="closeMarkSheet"
                    >
                        <v-icon>mdi-window-close</v-icon>
                    </v-btn>            
                </v-card-title>
                <v-row class="px-4">
                    <v-col class="py-0">
                        <Header
                            @import="importWeeklyTests"
                            @admin-next-subject="setAdminNextSubject"
                        />
                        
                        <MarkSheet/>
                        <v-row class="mt-3 mr-4">
                            <v-spacer></v-spacer>
                            <div class="caption">
                                Total Students: {{ totalStudents }}
                            </div>
                        </v-row>
                    </v-col>
                </v-row>
                
                <v-overlay
                    :absolute="absolute"
                    :value="overlay"                    
                    color="grey lighten-5"
                    opacity="0.9"
                    class="pa-5"
                >                    
                    <Lesson parent-component="enter-marks" />
                    <LessonAdmin 
                        :next-subject="adminNextSubject"
                    />                    
                    <div 
                        class="d-flex flex-column justify-center align-center"
                        v-show="loading"
                    >    
                        <v-progress-circular 
                            transition="fade-transition" 
                            indeterminate 
                            size="64"                            
                            color="primary"
                            v-show="loading"
                        ></v-progress-circular>
                        <div 
                            class="primary--text mt-4"
                            v-show="loading"
                        >{{ progressText }}</div>
                    </div> 
                </v-overlay>
               
                <v-overlay
                    :absolute="absolute"
                    :value="overlayLoading"                    
                    color="grey lighten-5"
                    opacity="0.9"
                    class="pa-5"
                >                    
                    <div 
                        class="d-flex flex-column justify-center align-center"
                    >    
                        <v-progress-circular 
                            transition="fade-transition" 
                            indeterminate 
                            size="64"                            
                            color="primary"
                        ></v-progress-circular>
                        <div class="primary--text mt-4">
                            Loading...
                        </div>
                    </div> 
                </v-overlay>
               
            </v-card>
        </v-col>
        
        <v-bottom-sheet 
            v-model="sheet" 
            inset
            persistent
        >
            <v-row align="center" justify="center">
                <v-alert
                    :value="error"
                    prominent
                    type="error"
                    transition="scale-transition"
                    dense                        
                >
                    <v-row align="center">
                        <v-col>{{ errorMessage }}</v-col>
                    </v-row>
                </v-alert>
            </v-row>

            <v-sheet class="text-center px-10" height="200px">
                <v-row justify="end">
                    <div>
                        <v-btn
                            class="mt-1"
                            text
                            outlined
                            color="red"
                            @click="closeBottomSheet"
                        >close</v-btn>
                    </div>
                </v-row>                
                <v-form ref="form">
                    <v-textarea                                       
                        label="Subject Teacher Comments"                        
                        hint="Max 300 Characters"
                        rows="3"                                           
                        counter                                             
                        no-resize
                        v-model="customComment"
                        autofocus                        
                        persistent-hint
                        maxlength="300"                                                                                                                                        
                    >                        
                    </v-textarea>
                </v-form>                    
            </v-sheet>
        </v-bottom-sheet>

        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
        >
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
            </template>
        </v-snackbar>
    </v-row>    
</template>

<script>
import Header from './EnterMarksHeader'
import Lesson from './EnterMarksLesson'
import MarkSheet from './EnterMarksSheet'
import LessonAdmin from './EnterMarksLessonAdmin'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    name: 'EnterMarks',

    created: function () {
        this.initialize();
    },

    components: {
        Header,
        Lesson,
        LessonAdmin,
        MarkSheet,
    },

    watch: {
        index: {
            handler (val) {
                //console.log(`Index Changed: ${val}`);
                this.customComment = this.table2Records[val].custom_comment;
            }
        }       
    },

    computed: {
        ...mapGetters({
            overlay: 'termReports/getMarkSheetOverlay',
            loading: 'termReports/getMarkSheetLoading',
            totalStudents: 'termReports/getSubjectStudentsTotal',
            lessonSelected: 'termReports/getLessonSelected',
            progressText: 'termReports/getProgressText',
            sheet: 'termReports/getCommentSheetEnterMarks',
            index: 'termReports/getSelectedTable2RecordIndex',
            table2Records: 'termReports/getTable2Records',
            admin: 'auth/getAdmin',  
            employeeId: 'auth/getEmployeeId',
        }),

    },

    data: () => ({
        absolute: true,             
        userTimetable: [],
        bottomSheetModel: null,
        errorMessage: null,
        error: false,
        customComment: null,
        overlayLoading: false,
        snackbar: {
            show: false,
            text: null,
            color: 'primary',
        },
        adminNextSubject: false,
    }),
    
    methods: {
        ...mapMutations({
            mainMenu: 'termReports/setMainMenu',
            enterMarks: 'termReports/setEnterMarks',
            setMarkSheetOverlay: 'termReports/setMarkSheetOverlay',
            setMarkSheetLoading: 'termReports/setMarkSheetLoading',
            expand: 'termReports/setExpandLessonOptions',
            welcomeMessage: 'termReports/setWelcomeMessage',
            setTable2Records: 'termReports/setTable2Records',
            setStudentName: 'termReports/setMarkSheetStudentSelected',
            setOverlayLessons: 'termReports/setOverlayLessons',
            setCommentSheet: 'termReports/setCommentSheetEnterMarks',
            setUpdatedRecord: 'termReports/setUpdatedTable2Record',
        }),

        ...mapActions({
            postWeeklyTests: 'weeklyTests/importWeeklyTests',
            getStudents: 'termReports/getStudents',
        }),

        initialize () {
            this.expand(false);
            this.$nextTick(() => {
                this.setMarkSheetOverlay(true);
                this.setMarkSheetLoading(true);
            })
            
        },

        setLessonSelected(e){
            this.loading = true;
            console.log(e);
        },        

        closeMarkSheet(){
            this.setTable2Records([]);
            this.setOverlayLessons(true);
            this.setMarkSheetOverlay(true);            
            this.setStudentName(''); 
            this.adminNextSubject = false;
        },

        closeBottomSheet () {
            //console.log(this.table2Records.indexOf(this.selectedTable2Record));
            this.table2Records[this.index].custom_comment = this.customComment;
            this.setCommentSheet(false);
        },

        async importWeeklyTests () {
            this.overlayLoading = true;
            try {
                const response  = await this.postWeeklyTests();
                console.log(response);
                await this.getStudents(this.employeeId);
                this.snackbar.show = true;
                this.snackbar.color = 'primary';
                this.snackbar.text = 'Weekly Tests Imported';
            } catch (error) {
                this.snackbar.show = true;
                this.snackbar.color = 'red';
                this.snackbar.text = 'An Error Occured';
                error.response ? console.log(error.response) : console.log(error);
            }
            this.overlayLoading = false;
        },

        setAdminNextSubject () {
            this.adminNextSubject = true;
        }

        
    }
}
</script>

<style scoped>
    ::v-deep .v-text-field__slot textarea{
        font-size: "1rem";
    }
</style>